import { ForecastSettings } from "./types";

export const DEFAULT_SETTINGS: ForecastSettings = {
  maxCaseload: 40,
  bufferPercent: 20,
  malePercent: 20,
  mentorsPerLead: 15,
  mentorsPerSupervisor: 25,
  growthPercent: 15,
};

export const STORAGE_KEY = "mentor-forecasting-settings";
export const TEEN_FORECAST_STORAGE_KEY = "mentor-forecasting-teen-forecasts";
export const MENTORS_LEAVING_STORAGE_KEY = "mentor-forecasting-mentors-leaving";

export const MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

export const AVAILABLE_YEARS = [2025, 2026];
